// Production stand-in for src/local/migrate.js.
//
// A deployment transfer moves a panel between this browser's IndexedDB and our
// servers. In a cloud build there is no IndexedDB half to move, so `@local`
// resolves here and none of the transfer machinery is in the bundle at all.
//
// The direction constants and the two read-only helpers answer honestly rather
// than throwing, because TransferLanding.vue imports them unconditionally and
// reads them while rendering — a throw during render would break a screen
// instead of hiding a button. `transfer` itself throws with the reason named,
// for the same reason the backup stand-ins do: a mis-wired build should fail
// legibly rather than resolve to `undefined` and die at the call site.

export const CLOUD_TO_LOCAL = 'cloud-to-local';
export const LOCAL_TO_CLOUD = 'local-to-cloud';

export const lastTransfer = () => null;
export const forgetTransfer = () => {};
export const directionFromLicence = () => null;
export const describeLocalPanel = async () => ({ counts: {}, clinicalRows: 0, isEmpty: true });

export const transfer = async () => {
  throw new Error('Deployment transfers are on-premise only; this build has no local database');
};

// Answers rather than throwing, unlike `transfer`: App.vue calls this on every
// start-up in every build. In a cloud build there is no pending move because
// there is no local database to move anything to or from.
export const runPendingTransfer = async () => ({ ran: false, reason: 'not_local_build' });
